import { Outlet } from "react-router";

export default function StandAloneLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
